export const environment = {
  production: true,
  emailjs: {
    serviceId: "service_oa5o4rg",
    templateId: "template_3ggafdr",
    publicKey: "hrerckyIx306PvNZw"
  }
};
